<template>
  <div class="type-filter">
    <TypeFilterButton v-for="t in typeConfigs" :key="t.key" :color-index="colorIndexForType(t.key)"
                      :active="!!displayStatusByType[t.key]" @click="toggle(t.key)">
      {{ i18n.t(t.labelKey) }}
    </TypeFilterButton>
  </div>
</template>

<script>
import TypeFilterButton from './type-filter-button'

const ALL_TYPES = ['event','group']
const TYPE_TO_I18N_KEY_MAP = {
  event: 'activerecord.models.event.other',
  group: 'activerecord.models.local_chapter.other'
}

export default {
  components: { TypeFilterButton },

  props: {
    initialTypes: {
      type: Array,
      default: () => ALL_TYPES
    }
  },

  emits: ['change'],

  data() {
    return {
      typeConfigs: ALL_TYPES.map(typeName => ({
        key: typeName,
        labelKey: TYPE_TO_I18N_KEY_MAP[typeName]
      }))
    }
  },

  computed: {
    displayStatusByType() {
      return typesArrayToObject(this.initialTypes)
    }
  },

  methods: {
    toggle(type) {
      const newTypesObject = {...this.displayStatusByType, [type]: !this.displayStatusByType[type]}
      if (ALL_TYPES.some(typeName => !newTypesObject[typeName])) {
        this.$emit('change', displayStatusByTypeToArray(newTypesObject))
      }
      else {
        // All possible types are selected, so we remove the filter entirely
        // by sending a null value
        this.$emit('change', null)
      }
    }
  }
}

function typesArrayToObject(typesArray) {
  let obj = {}
  typesArray.forEach(typeName => {
    obj[typeName] = true
  })
  return obj
}

function displayStatusByTypeToArray(displayStatusByType) {
  // get array consisting of keys that are "true" in the `displayStatusByType` object
  return Object.entries(displayStatusByType).filter(([_k,v]) => v).map(([k, _v])=> k)
}
</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

.type-filter {
  background-color: colors.$widget-background-light-gray;
}
</style>
